import { render, staticRenderFns } from "./PassengerflowView.vue?vue&type=template&id=0c2d3974&scoped=true"
import script from "./PassengerflowView.vue?vue&type=script&lang=js"
export * from "./PassengerflowView.vue?vue&type=script&lang=js"
import style0 from "./PassengerflowView.vue?vue&type=style&index=0&id=0c2d3974&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2d3974",
  null
  
)

export default component.exports